export default __webpack_public_path__ + "static/media/tv-icon.61adc6cf.svg";